document.addEventListener('DOMContentLoaded', () => {
	const hamburger = document.getElementById('js-hamburger');
	const nav = document.getElementById('js-header-nav');
	const overlay = document.getElementById('js-nav-overlay');

	if (!hamburger || !nav || !overlay) return;

	const openNav = () => {
		hamburger.classList.add('is-active');
		nav.classList.add('is-active');
		overlay.classList.add('is-active');
	};

	const closeNav = () => {
		hamburger.classList.remove('is-active');
		nav.classList.remove('is-active');
		overlay.classList.remove('is-active');
	};

	hamburger.addEventListener('click', () => {
		nav.classList.contains('is-active') ? closeNav() : openNav();
	});

	overlay.addEventListener('click', closeNav);
	nav.querySelectorAll('a').forEach((link) => {
		link.addEventListener('click', closeNav);
	});
});
